// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"178":"43df491c","371":"96a7d488","551":"48d82f6f"}[chunkId] + ".chunk.js";
};